// extracted by mini-css-extract-plugin
export default {"container":"switch_container__94E3u","slider":"switch_slider__yobbG","label":"switch_label__8M2Es","active":"switch_active__MadxM"};